import { useLocation } from '@remix-run/react'
import { useEffect } from 'react'

export function preserveSearchParams(
	searchParams: URLSearchParams,
	baseUrl: string,
	paramsToPreserve: string[] = ['view', 'search'],
): string {
	const params = new URLSearchParams()

	for (const param of paramsToPreserve) {
		const value = searchParams.get(param)
		if (value) {
			params.set(param, value)
		}
	}

	const queryString = params.toString()
	return queryString ? `${baseUrl}?${queryString}` : baseUrl
}

export function getWorkUrl(searchParams: URLSearchParams): string {
	return preserveSearchParams(searchParams, '/work')
}

export function getWorkUrlWithAnimation(searchParams: URLSearchParams): string {
	const baseUrl = preserveSearchParams(searchParams, '/work', [
		'view',
		'search',
	])
	const separator = baseUrl.includes('?') ? '&' : '?'
	return `${baseUrl}${separator}animate=false`
}

export function scrollToTop(behavior: ScrollBehavior = 'smooth'): void {
	window.scrollTo({
		top: 0,
		left: 0,
		behavior,
	})
}

/**
 * Hook that scrolls to top when the route changes
 */
export function useScrollToTop() {
	const location = useLocation()

	useEffect(() => {
		scrollToTop()
	}, [location.pathname])
}
